module.exports = __webpack_public_path__ + "static/ptx_white_logo-3b683f1410c227cf638e9095267ab502.png";